<template>
  <div class="ArtifactSidePanel">
    <div class="ArtifactSidePanel__header">
        <span style="font-weight: bold; font-size: 16pt">{{ openedArtifact.title }}</span>
        <v-btn icon @click="closeArtifact"><v-icon> {{ 'mdi-close-circle' }} </v-icon></v-btn>
    </div>
    <div class="ArtifactSidePanel__content">
        <v-tabs
          v-model="selectedTab"
          align-tabs="center"
        >

          <v-tab :value="1">View</v-tab>
          <v-tab :value="2">Raw</v-tab>

          <v-tab-item class="ArtifactSidePanel__contentTab">
            <div class="ArtifactSidePanel__htmlContent">
              <iframe v-if="openedArtifact.type === 'html'" :srcdoc="openedArtifact.content" frameborder="0" style="overflow-y: auto; height: calc(100vh - 370px); width: 100%;"></iframe>
                <span v-if="openedArtifact.type !== 'html'">
                  <div v-html="renderMarkdown(openedArtifact.content)" style="height: calc(100vh - 370px); overflow-y: auto">

                  </div>
                </span>
            </div>
          </v-tab-item>
          <v-tab-item class="ArtifactSidePanel__contentTab">
            <div class="ArtifactSidePanel__rawContent">
              <span style="word-wrap: break-word;">
               {{ openedArtifact.content }}
              </span>
            </div>
          </v-tab-item>

        </v-tabs>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import Vue from "vue";
import { createNamespacedHelpers } from 'vuex';
import markdownit from 'markdown-it';

const {
  mapGetters: AIChatGetters,
  mapMutations: AIChatMutations,
} = createNamespacedHelpers("AIChat");

Vue.use(VueLoaders);

export default {
  name: 'artifact-sidepanel',
  components: {},
  mixins: [helpers],
  data() {
    return {
      selectedTab: "1",
    };
  },
  computed: {
    ...AIChatGetters({
      openedArtifact: 'GET_CHAT_ARTIFACT'
    })
  },
  methods: {
    ...AIChatMutations({
      setArtifact: 'SET_CHAT_ARTIFACT',
    }),
    renderMarkdown(text) {
      const md = markdownit({
        breaks: true,
        linkify: true,
      });
      return md.render(text);
    },
    closeArtifact() {
      this.setArtifact(null);
    }
  },
};
</script>

<style scoped lang="scss">
@import './artifact-sidepanel';
</style>
